import React from 'react';
import ReactDOM from 'react-dom';

import './public.js';

import init from './init';

import App from './App';

init();

ReactDOM.render(<App />, document.getElementById('root'));
